/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createConsumptionHistoryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type ConsumptionGranularity, type ConsumptionHistory, type ProblemDetails } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type DateOnly, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints/{id}/consumption/history
 */
export interface HistoryRequestBuilder extends BaseRequestBuilder<HistoryRequestBuilder> {
    /**
     * GetChargePointConsumptionHistory
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ConsumptionHistory>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<HistoryRequestBuilderGetQueryParameters> | undefined) : Promise<ConsumptionHistory | undefined>;
    /**
     * GetChargePointConsumptionHistory
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<HistoryRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetChargePointConsumptionHistory
 */
export interface HistoryRequestBuilderGetQueryParameters {
    date?: DateOnly;
    granularity?: ConsumptionGranularity;
}
/**
 * Uri template for the request builder.
 */
export const HistoryRequestBuilderUriTemplate = "{+baseurl}/chargepoints/{id}/consumption/history?Granularity={Granularity}{&Date*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const HistoryRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "date": "Date",
    "granularity": "Granularity",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const HistoryRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: HistoryRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createConsumptionHistoryFromDiscriminatorValue,
        queryParametersMapper: HistoryRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
